
<div>
  <altcha-widget
    ref="altchaWidget"
    challengeurl="/api/altcha"
    :strings="strings"
    :auto="auto"
    floating="auto"
    name="a_c"
    hidelogo
    hidefooter
  ></altcha-widget>
</div>
